import { render } from "./AddrIcon.vue?vue&type=template&id=51dab611"
import script from "./AddrIcon.vue?vue&type=script&lang=js"
export * from "./AddrIcon.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__